import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from 'react';
import { createTimestampAndNextNDays } from '@/utils/GlobalJavascriptFunction';
import { useLang } from '@/common/Contexts/LanguageContext';
import { useTranslation } from '@i18n';
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import { twMerge } from "tailwind-merge";

// SingleTimeSlot component
var SingleTimeSlot = function SingleTimeSlot(_ref) {
  var text = _ref.text,
    disabled = _ref.disabled,
    active = _ref.active,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("px-4 py-1.5 rounded-lg border-2 border-solid transition-all duration-200 min-w-[155px] border-gray-300 bg-white text-gray-700 cursor-pointer text-center text-base", disabled && "border-gray-300 bg-gray-100 text-gray-400 cursor-not-allowed", active && "border-primary text-primary font-semibold bg-blue-50"),
    onClick: onClick
  }, text);
};
var TimeSlots = function TimeSlots(_ref2) {
  var errorAppointment = _ref2.errorAppointment,
    updateError = _ref2.updatError;
  var _usePriceOfferContext = usePriceOfferContext(),
    scheduleData = _usePriceOfferContext.scheduleData,
    actions = _usePriceOfferContext.actions,
    state = _usePriceOfferContext.state,
    slotsLoader = _usePriceOfferContext.slotsLoader,
    daysLoader = _usePriceOfferContext.daysLoader;
  var _useState = useState(null),
    activeSlot = _useState[0],
    setActiveSlot = _useState[1];
  var lang = useLang();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var availableDayTimes = scheduleData.availableDayTimes,
    showTimeLoader = scheduleData.showTimeLoader;
  var setSelectedDayAndTime = actions.setSelectedDayAndTime;
  var isUserLocation = state.inspection_location === 'user_location';

  // Reset active slot when available times change
  useEffect(function () {
    setActiveSlot(null);
  }, [availableDayTimes]);
  var handleTimeSlotClick = function handleTimeSlotClick(timeSlot, index) {
    if (!timeSlot.is_active) return;
    setActiveSlot(index);
    setSelectedDayAndTime({
      from: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from_timestamp,
      to: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.to_timestamp
    });

    // Clear any previous errors
    if (updateError) {
      updateError();
    }
  };

  // Show loader while fetching time slots
  if (showTimeLoader) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex justify-center items-center py-8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"
    }));
  }

  // Show message when no time slots available
  if (!daysLoader.value && !slotsLoader.value && (!availableDayTimes || availableDayTimes.length === 0)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-center py-8 text-gray-500"
    }, /*#__PURE__*/React.createElement("p", null, t("لا توجد مواعيد متاحة لهذا اليوم", {
      ns: "web_Schedule"
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-3"
  }, availableDayTimes.map(function (timeSlot, index) {
    var fromTime = createTimestampAndNextNDays(timeSlot.from_timestamp);
    var toTime = createTimestampAndNextNDays(timeSlot.to_timestamp);
    var timeText = "".concat(fromTime.timeForView(lang), " - ").concat(toTime.timeForView(lang));
    return /*#__PURE__*/React.createElement(SingleTimeSlot, {
      key: "".concat(timeSlot.from_timestamp, "-").concat(timeSlot.to_timestamp, "-").concat(index),
      text: timeText,
      disabled: !timeSlot.is_active,
      active: activeSlot === index,
      onClick: function onClick() {
        return handleTimeSlotClick(timeSlot, index);
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 text-sm text-gray-600"
  }, /*#__PURE__*/React.createElement("p", null, isUserLocation ? t("مواعيد الفحص تبدأ من الساعة 9 صباحاً حتى الساعة 5 مساءا", {
    ns: "web_Schedule"
  }) : t("مواعيد الفحص تبدأ من الساعة 9 صباحاً حتى الساعة 9 مساءا", {
    ns: "web_Schedule"
  }))), errorAppointment && /*#__PURE__*/React.createElement("div", {
    className: "mt-4 bg-red-50 border border-red-200 rounded-lg p-4 flex items-start space-x-3 rtl:space-x-reverse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "w-5 h-5 text-red-600 mt-0.5",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "text-red-800 font-semibold"
  }, t("تم حجز الموعد من قبل عميل اخر", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-red-700 mt-1"
  }, t("قم بحجز موعد آخر", {
    ns: "web_Schedule"
  }))))));
};

// Single skeleton time slot
export var SingleTimeSlotSkeleton = function SingleTimeSlotSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-1.5 rounded-lg border-2 border-gray-200 bg-gray-50 min-w-[155px] animate-pulse"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-6 bg-gray-200 rounded w-full"
  }));
};

// Main skeleton component
export var TimeSlotsSkeleton = function TimeSlotsSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-4"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-3"
  }, Array.from({
    length: 6
  }).map(function (_, index) {
    return /*#__PURE__*/React.createElement(SingleTimeSlotSkeleton, {
      key: index
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 text-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 rounded w-3/4 animate-pulse"
  }))));
};
export default TimeSlots;